<div class="container-fluid mb-2">
  <div class="row">
    <div class="col-12 mt-2">

      <form autocomplete="off" [formGroup]="form" (ngSubmit)="autoRefresh = true;">
          <div class="card mb-3 bg-2">
            <div class="card-body">
              <div class="row mt-2 d-flex">
                <div class="col-md-12 col-lg-6 carteira">
                  <carteira-autocomplete [schema]="carteiraSchema"></carteira-autocomplete>
                </div>
              </div>
              <div class="row mt-2 d-flex">
                <div class="col-sm-6 col-lg-3 col-xl-2 ultima-data">
                  <lib-datepicker-day [schema]="ultimaDataEnquadramentoSchema"></lib-datepicker-day>
                </div>
                <div class="col-sm-5 col-lg-3 col-xl-2 status">
                  <lib-select-one [schema]="statusSchema" [data]="status"></lib-select-one>
                </div>
                <div class="col-sm-1 col-lg-3 col-xl-6 pl-0 pt-3">
                  <button mat-icon-button type="button" class="tooltip-400" [tooltip]="popTemplate">
                    <i class="fa fa-info-circle"></i>
                  </button>
                  <ng-template #popTemplate
                    ><span style="font-size: 0.9em !important">
                      Refere-se ao status geral da carteira quanto as regras
                      de enquadramento associadas:
                      <ul>
                        <li>
                          Enquadrada - todas as regras associadas estão
                          enquadradas na data.
                        </li>
                        <li>
                          Desenquadrada - uma ou mais regras apresentam status
                          de desenquadrada na data.
                        </li>
                        <li>
                          Não processada - corresponde a carteira que ainda
                          não teve o primeiro dia de processamento do
                          enquadramento.
                        </li>
                        <li>
                          Pendente - refere-se ao status de uma carteira que
                          teve o processamento solicitado, mas que por algum
                          motivo deu erro e não foi concluído com sucesso.
                        </li>
                      </ul>
                    </span>
                  </ng-template>
                </div>
                <div class="col-sm-4 col-lg-3 col-xl-2 ml-auto data-proc">
                  <lib-datepicker-day #dataProcessamento [schema]="dataProcessarSchema"></lib-datepicker-day>
                </div>
              </div>
            </div>
            <div class="card-footer clearfix d-flex row">
              <div class="d-flex flex-row justify-content-start col-4">
                <div class="pr-3">
                  <button
                    mat-raised-button
                    color="primary"
                    [disabled]="processamentos.length == 0"
                    label="Processar Período"
                    type="submit"
                    title="Processar Período"
                    aria-label="left"
                    (click)="processarPeriodo()"
                  >
                  Processar Período
                  </button>
                </div>
                <div class="pr-3">
                  <button
                    id="cancelar-processamento"
                    mat-raised-button
                    class="maps-button"
                    [matMenuTriggerFor]="cancelar"
                    [disabled]="processamentos.length == 0 || (cancelandoSelecionadas$ | async) || (cancelandoTodas$ | async)">
                    <div class="maps-button__spinner">
                      <mat-spinner
                        class="me-2"
                        diameter="20"
                        *ngIf="(cancelandoSelecionadas$ | async) || (cancelandoTodas$ | async)"></mat-spinner>
                      <span *ngIf="((cancelandoSelecionadas$ | async) || (cancelandoTodas$ | async)) === false"
                        >Cancelar Processamento <i class="fas fa-solid fa-caret-down ms-2"></i
                      ></span>
                      <span *ngIf="(cancelandoSelecionadas$ | async) || (cancelandoTodas$ | async)">Cancelando...</span>
                    </div>
                  </button>
                  <mat-menu #cancelar="matMenu">
                    <button
                      id="cancelar-processamento-selecionadas"
                      mat-menu-item
                      [disabled]="getProcessamentosSelecionados().length === 0 || (cancelandoSelecionadas$ | async)"
                      (click)="cancelarSelecionadas()">
                      Cancelar Selecionadas
                    </button>
                    <button
                      id="cancelar-processamento-todas"
                      mat-menu-item
                      [disabled]="processamentos.length == 0 || (cancelandoTodas$ | async)"
                      (click)="cancelarTodas()">
                      Cancelar Todas
                    </button>
                  </mat-menu>

                </div>
              </div>
              <div class="d-flex flex-row justify-content-end col-8">
                <div class="pr-3">
                  <button
                    mat-raised-button
                    color="primary"
                    [disabled]="form.invalid || isLoading"
                    label="Pesquisar"
                    type="submit"
                    title="Pesquisar"
                    aria-label="left"
                    (click)="btnPesquisar()"
                  >
                    <loading-icon [btnLabel]="'Pesquisar'" [loading]="isLoading"></loading-icon>
                  </button>
                </div>
                <div class="pr-3">
                  <button
                    mat-raised-button
                    color="primary"
                    label="Processar selecionadas"
                    type="button"
                    (click)="executarProcessamento(this.form.value)"
                    title="Processar selecionadas"
                    aria-label="left"
                    [disabled]="desabilitarProcessamento(this.form.value)"
                  >
                    Processar selecionadas
                  </button>
                </div>
                <div class="pr-3">
                  <button
                    mat-raised-button
                    color="primary"
                    label="Processar todas"
                    type="button"
                    (click)="confirmarConfirmarProcessamentoTodas()"
                    title="Processar  todass"
                    aria-label="left"
                    [disabled]="processamentos.length == 0 || this.form.value.dataProcessamento === null"
                  >
                    Processar todas
                  </button>
                </div>
                <div>
                  <button mat-raised-button
                          [matMenuTriggerFor]="menuExportarProcessamento"
                          [disabled]="(loadingExport$ | async)">
                    <loading-icon
                      [btnLabel]="'Exportar'"
                      [loading]="loadingExport$ | async"
                    ></loading-icon> <span class="caret"></span>
                  </button>
                  <mat-menu #menuExportarProcessamento="matMenu">
                    <button mat-menu-item (click)="exportarPdf()">
                      <span>PDF</span>
                    </button>
                    <button mat-menu-item (click)="exportarXls()">
                      <span>Excel</span>
                    </button>
                  </mat-menu>
                </div>
            </div>
            </div>
          </div>
      </form>
      <app-total-table
        [showRegistersPerPage]="true"
        (onChange)="updatePageSize($event)"
        [totalRegistros]="this.totalRegistros"
        [totalSelecionados$]="totalSelecionados$"
      ></app-total-table>
      <table aria-label="Carteiras para processar"
        class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl"
      >
        <thead>
          <tr>
            <th scope="col">
              <mat-checkbox value="null" class="align-middle" [color]="'primary'" [checked]="allSelected()" #allCheckbox
              (change)="selectAll($event)"></mat-checkbox>
            </th>
            <th scope="col">Nome</th>
            <th scope="col">Última data processamento</th>
            <th scope="col">Status</th>
            <th scope="col" class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of processamentos; let i = index">
            <td class="justify-content-center">
              <mat-checkbox
                type="checkbox"
                [color]="'primary'"
                [(ngModel)]="p.check"
                (change)="checkboxChange(p.check, p.carteiraId)"
              ></mat-checkbox>
            </td>
            <td>{{ p.carteira }}</td>
            <td>{{ verificaDataEnquadramento(p.ultimaDataProcessamento) }}</td>
            <td>{{ p.statusProcessamento }}</td>
            <td class="pt-1 pb-1">
              <div class="d-flex justify-content-center">
                <div class="pr-2">
                  <button
                    mat-icon-button
                    type="button"
                    [disabled]="p.statusProcessamento == 'Pendente' || p.statusProcessamento == 'Não processada'"
                    (click)="showDetails(p)"
                    title="Detalhe último processamento"
                  >
                    <i class="fas fa-search" aria-hidden="true"></i>
                  </button>
                </div>
                <div class="pr-2">
                  <button
                    mat-icon-button
                    type="button"
                    [disabled]="p.statusProcessamento == 'Não processada'"
                    (click)="confirmDialog(p)"
                    title="Últimos 10 processamentos"
                    data-toggle="modal"
                    data-target="#confirm-dialog-modal"
                  >
                    <i class="fas fa-list" aria-hidden="true"></i>
                  </button>
                </div>
                <div>
                  <button
                    mat-icon-button
                    [disabled]="p.statusProcessamento != 'Pendente'"
                    type="button"
                    (click)="showDetailsLogErro(p)"
                    title="Log erro"
                  >
                    <i class="fas fa-exclamation-triangle" [class.text-yellow]="p.statusProcessamento == 'Pendente'" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-center mb-5">
        <maps-pagination [pageNumber]="pageNumber$"
          [items]="paginationTotalPage"
          *ngIf="paginationTotalPage && paginationTotalPage > 0"
          (pageSend)="receiverPage($event)"
        ></maps-pagination>
      </div>
    </div>
  </div>
</div>
